/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SalaryRangeAnalysisPoint } from './SalaryRangeAnalysisPoint';

export type SalaryRangeAnalysisDistributionBucket = {
    type: SalaryRangeAnalysisDistributionBucket.type;
    index: number | null;
    low: number | null;
    high: number | null;
    employees: Array<SalaryRangeAnalysisPoint>;
};

export namespace SalaryRangeAnalysisDistributionBucket {

    export enum type {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

